export const iconFontAwesomeHumanitarianPersonCircleQuestion = (
	<i className="fa-solid fa-person-circle-question"></i>
);
